import './overview.scss';
import Swiper from 'swiper/swiper-bundle';

export default () => {
	new Swiper( '.js-overview-slider', {
		slidesPerView: 1,
		loop: true,
		pagination: {
			el: '.overview__dots',
			clickable: true,
		},
		navigation: {
			prevEl: '.overview-prev',
			nextEl: '.overview-next',
		},
	} );
};
